import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [{
            //重定向路由
            path: '/',
            redirect: '/home'
        },
        //业务逻辑页
        {
            path: "/home",
            component: resolve => require(['../components/root/home.vue'], resolve),
            children: [
                //首页  系统首页
                {
                    path: "/",
                    component: resolve => require(['../views/system/index.vue'], resolve),
                },
            ]
        },

    ]
})